import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import moment from 'moment-timezone'
import queryString from 'query-string'

function getCategoryAnalyticsDetails(filter) {
  let {startDate, endDate, storeNames, productField, productFieldValues, interval, advanceFilters} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    startDate: startDateParam,
    endDate: endDateParam,
    stores: storeNames,
    productField: productField,
    productFieldValues: productFieldValues,
    advanceFilters: JSON.stringify(advanceFilters)
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/category-analytics/${interval}/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(r => r.json())
}

function getCategoryAnalyticsDetailsWithComparison(filter, changesFrom) {
  let {
    startDate, endDate, storeNames, productField, productFieldValues, interval, advanceFilters,
    productFieldForMerchandiseSales
  } = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let prevStartDateParam = moment(startDate).subtract(1, 'year').format('YYYY-MMM-DD')
  let prevEndDateParam = moment(endDate).subtract(1, 'year').format('YYYY-MMM-DD')
  let query = queryString.stringify({
    startDate: startDateParam,
    endDate: endDateParam,
    prevStartDate: prevStartDateParam,
    prevEndDate: prevEndDateParam,
    stores: storeNames,
    productField: changesFrom === 'summary' ? productFieldForMerchandiseSales : productField,
    productFieldValues: productFieldValues,
    advanceFilters: JSON.stringify(advanceFilters)
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/category-analytics/compare/${interval}/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(r => r.json())
}

export default {
  getCategoryAnalyticsDetails,
  getCategoryAnalyticsDetailsWithComparison
}



// WEBPACK FOOTER //
// ./src/services/category-analytics-service.js